<template>
  <div>
    <b-tabs
      pills
      fill
    >
      <b-tab>
        <template #title>
          <feather-icon icon="InfoIcon" />
          Bilgiler
        </template>
        <b-form-group
          label="Başlık"
          label-for="title"
        >
          <b-form-input
            id="title"
            v-model="itemData.translate.title"
            placeholder="Başlık"
          />
          <b-alert show>
            <div class="alert-body mt-1 font-small-2">
              {{ itemData.item.title }}
            </div>
          </b-alert>
        </b-form-group>
        <b-form-group
          label="İçerik"
          label-for="content"
        >
          <quill-editor
            id="content"
            v-model="itemData.translate.content"
            class="bg-white"
            :options="editorOption"
          >
            <div
              id="content_toolbar"
              slot="toolbar"
            >
              <editor-toolbar />
            </div>
          </quill-editor>
          <b-alert show>
            <div class="alert-body mt-1 font-small-2">
              <div v-html="itemData.item.content" />
            </div>
          </b-alert>
        </b-form-group>
        <template v-if="itemData.item.form_component !== 'CorporatePoliciesStandartForm'">
          <b-form-group
            label="Alt Başlık"
            label-for="subtitle"
          >
            <b-form-input
              id="subtitle"
              v-model="itemData.translate.subtitle"
              placeholder="Alt Başlık"
            />
            <b-alert show>
              <div class="alert-body mt-1 font-small-2">
                {{ itemData.item.subtitle }}
              </div>
            </b-alert>
          </b-form-group>
          <b-form-group
            label="Alt İçerik"
            label-for="subcontent"
          >
            <quill-editor
              id="subcontent"
              v-model="itemData.translate.subcontent"
              class="bg-white"
              :options="tcEditorOption"
            >
              <div
                id="technical_content_toolbar"
                slot="toolbar"
              >
                <editor-toolbar />
              </div>
            </quill-editor>
            <b-alert show>
              <div class="alert-body mt-1 font-small-2">
                <div v-html="itemData.item.subcontent" />
              </div>
            </b-alert>
          </b-form-group>
        </template>

      </b-tab>
      <b-tab v-if="itemData.item.form_component === 'CorporatePoliciesSubTitleForm'">
        <template #title>
          <feather-icon icon="InfoIcon" />
          Alt Başlıklar
        </template>
        <b-row
          v-for="(row,index) in itemData.item.items"
          :key="index"
        >
          <b-col
            cols="6"
            md="6"
          >
            <b-form-group label="Başlık">
              <b-form-input
                v-model="itemData.translate.items[index].title"
                placeholder="Giriniz"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="6"
            md="6"
          >
            <b-form-group label="İçerik">
              <b-form-input
                v-model="itemData.translate.items[index].content"
                placeholder="Giriniz"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="6"
            md="6"
          >
            <b-alert show>
              <div class="alert-body mt-1 font-small-2">
                <div v-html="row.title" />
              </div>
            </b-alert>
          </b-col>
          <b-col
            cols="6"
            md="6"
          >
            <b-alert show>
              <div class="alert-body mt-1 font-small-2">
                <div v-html="row.content" />
              </div>
            </b-alert>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
    <b-button
      variant="primary"
      size="sm"
      @click="saveAction"
    >
      <FeatherIcon icon="SaveIcon" />
      Kaydet
    </b-button>
  </div>
</template>
<script>
import {
  BFormGroup, BFormInput, BAlert, BButton, BTabs, BTab, BRow, BCol,
} from 'bootstrap-vue'
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import EditorToolbar from '@/layouts/components/common/EditorToolbar.vue'

export default {
  name: 'Contents',
  components: {
    EditorToolbar,
    BFormGroup,
    BFormInput,
    BAlert,
    BButton,
    quillEditor,
    BTabs,
    BTab,
    BRow,
    BCol,
  },
  props: {
    saveAction: {
      type: Function,
      require: true,
    },
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: '#content_toolbar',
        },
        theme: 'snow',
      },
      tcEditorOption: {
        modules: {
          toolbar: '#technical_content_toolbar',
        },
        theme: 'snow',
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['translate/dataItem']
    },
  },
}
</script>
